import React from 'react';
import { Typography } from '../typography/typography';
import styles from './empty-state.module.scss';

type Props = {
  title: string;
  description: string;
  /**
   * Intended to be used for one primary button and optional secondary buttons.
   */
  children: React.ReactNode;
};

export const EmptyState: React.FC<Props> = ({ title, description, children }) => {
  return (
    <div className={styles.root}>
      <Typography className={styles.title} variant="headline-3">
        {title}
      </Typography>
      <Typography className={styles.description} variant="maintext">
        {description}
      </Typography>
      <div className={styles.actions}>{children}</div>
    </div>
  );
};
